
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/care/list",
      function () {
        return require("private-next-pages/care/list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/care/list"])
      });
    }
  